import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["disabled", "id"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "form-control-plaintext" }
const _hoisted_7 = ["for"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "form-control-plaintext" }
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "form-control-plaintext" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "form-control-plaintext" }
const _hoisted_14 = ["for"]
const _hoisted_15 = ["for"]
const _hoisted_16 = ["for"]
const _hoisted_17 = ["src", "id", "title"]
const _hoisted_18 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_19 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "form-control-plaintext uploadWithPreviewNoDestination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_ShowLabelStatus = _resolveComponent("ShowLabelStatus")!
  const _component_FormGridColumn = _resolveComponent("FormGridColumn")!
  const _component_NotFoundResolutionDialog = _resolveComponent("NotFoundResolutionDialog")!
  const _component_FormGridLocal = _resolveComponent("FormGridLocal")!

  return (_openBlock(), _createBlock(_component_FormGridLocal, {
    columns: _ctx.file == null ? 1 : 2
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FormGridColumn, null, {
          default: _withCtx(() => [
            _createVNode(_component_FormGridMember, null, {
              label: _withCtx(({ controlId, class: clazz }) => [
                _createElementVNode("label", {
                  class: _normalizeClass(`col-form-label ${clazz}`),
                  for: controlId
                }, _toDisplayString(_ctx.$t('review.upload.preview.file')), 11, _hoisted_2)
              ]),
              control: _withCtx(({ id }) => [
                _createElementVNode("input", {
                  class: _normalizeClass({ 'form-control': true, 'is-invalid': this.showRetryButton }),
                  disabled: this.disabled,
                  id: id,
                  type: "file",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => {this.startNextUpload($event.target.files[0] ?? null);}),
                  required: ""
                }, null, 42, _hoisted_3),
                _createElementVNode("div", null, [
                  (this.doShowRetryButton())
                    ? (_openBlock(), _createBlock(_component_i18n_t, {
                        key: 0,
                        keypath: "review.upload.preview.uploadError"
                      }, {
                        reload: _withCtx(() => [
                          _createElementVNode("button", {
                            disabled: this.disabled,
                            type: "button",
                            class: "btn btn-outline-secondary btn-sm",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.retry()))
                          }, _toDisplayString(_ctx.$t('review.upload.preview.retryUpload')), 9, _hoisted_4)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (this.file == null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('review.upload.preview.noFile')), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            (this.file != null && this.seekLabelResult != null
                        && this.uploadInfo != null && this.uploadInfo !== _ctx.loadingPlaceholder)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_FormGridMember, { class: "uploadWithPreviewMember" }, {
                    label: _withCtx(({ controlId, class: clazz }) => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${clazz}`),
                        for: controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.localName')), 11, _hoisted_5)
                    ]),
                    control: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.file.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormGridMember, { class: "uploadWithPreviewMember" }, {
                    label: _withCtx(({ controlId, class: clazz }) => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${clazz}`),
                        for: controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.rotation')), 11, _hoisted_7)
                    ]),
                    control: _withCtx(() => [
                      _createVNode(_component_Select, {
                        mode: "flex",
                        id: _ctx.id,
                        selectClass: "form-select",
                        options: this.validRotations,
                        modelValue: _ctx.seekLabelResult.previewRotation,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.seekLabelResult.previewRotation) = $event)),
                        disabled: !this.selectRotationPossible
                      }, null, 8, ["id", "options", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormGridMember, { class: "uploadWithPreviewMember" }, {
                    label: _withCtx(({ controlId, class: clazz }) => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${clazz}`),
                        for: controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.size')), 11, _hoisted_8)
                    ]),
                    control: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.seekLabelResult }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$n((_ctx.seekLabelResult.urx - _ctx.seekLabelResult.llx) * (25.4 / 720.0))) + " x " + _toDisplayString(_ctx.$n((_ctx.seekLabelResult.ury - _ctx.seekLabelResult.lly) * (25.4 / 720.0))) + " cm ", 1)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormGridMember, { class: "uploadWithPreviewMember" }, {
                    label: _withCtx(({ controlId, class: clazz }) => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${clazz}`),
                        for: controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.pages')), 11, _hoisted_10)
                    ]),
                    control: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.seekLabelResult }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.seekLabelResult.numberOfPages), 1)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormGridMember, { class: "uploadWithPreviewMember" }, {
                    label: _withCtx(({ controlId, class: clazz }) => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${clazz}`),
                        for: controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.status')), 11, _hoisted_12)
                    ]),
                    control: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_LoadedOrPlaceholder, {
                          value: _ctx.uploadInfo,
                          lines: 2
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ShowLabelStatus, {
                              seekResult: _ctx.seekLabelResult,
                              uploadInfo: _ctx.uploadInfo
                            }, null, 8, ["seekResult", "uploadInfo"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormGridMember, { class: "uploadWithPreviewMember alert alert-primary" }, {
                    label: _withCtx(({ controlId, class: clazz }) => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${clazz}`),
                        for: controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.alert')), 11, _hoisted_14)
                    ]),
                    control: _withCtx(() => [
                      _createElementVNode("label", {
                        class: _normalizeClass(`col-form-label ${_ctx.clazz}`),
                        for: _ctx.controlId
                      }, _toDisplayString(_ctx.$t('review.upload.preview.alertText')), 11, _hoisted_15)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (this.file != null)
          ? (_openBlock(), _createBlock(_component_FormGridColumn, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("label", {
                  class: "col-form-label",
                  for: _ctx.$id('preview')
                }, _toDisplayString(_ctx.$t('review.upload.preview.preview')), 9, _hoisted_16),
                _createElementVNode("div", null, [
                  (_ctx.imageLink != null)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imageLink,
                        id: _ctx.$id('preview'),
                        class: "btn",
                        title: _ctx.$t('review.upload.preview.pngPreview'),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPreviewWindow()))
                      }, null, 8, _hoisted_17))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_ctx.imageLink == null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('review.upload.preview.noDestination')), 1))
                      ]))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_NotFoundResolutionDialog, { ref: "notFoundDialog" }, null, 512)
      ])
    ]),
    _: 1
  }, 8, ["columns"]))
}